import styled from 'styled-components';

export const NotifiBannerWrapper = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    width: inherit;
    min-height: 90px;
    background: ${({ bannerType }) => bannerType === 'critical' ? `var(--feedback-error-background, #FFECE0)` :
        (bannerType === 'info' ? `var(--feedback-information-background, #E3F2FD)` : `var(--feedback-warning-background, #FFF9DE)`)};
    border-bottom: ${({ isEventAlert, bannerType }) => isEventAlert ? (bannerType === 'critical' ? '4px solid #FF8027' : '4px solid #0089EC') : 'none'};
    border-radius: ${({ isEventAlert }) => !isEventAlert ? '4px' : 'none'};
    padding: 12px 16px;
    gap: 12px;
    align-items: center;
    z-index: 100;
    position: fixed;
    top: 0;

    @media (min-width: 1400px) {
        padding: 20px; 
    }
`;

export const TitleNSubTitleWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 70%;
    max-width: 100%;
    overflow: hidden;
    @media (max-width: 545px) {
        flex-basis: 100%;
    }

    /* Tablet & mobile: fill left side so button + close are pushed to the right */
    @media (max-width: 1399px) {
        width: auto;
    }
`;

export const BannerNotificationIcon = styled.img`
    width: 40px;
    height: 40px;
    margin-right: 15px;

    @media (max-width: 767px) {
        width: 28px;
        height: 28px;
        margin-right: 8px;
    }
`;

export const TitleSubTitleSegment = styled.div`
   display: flex;
   flex-direction: column;
`;

export const BannerNotifiCommonSegment = styled.div`
   {
    font-family: Verizon NHG DS;
    font-size: 16px;
    font-weight: ${({ segment }) => segment === 'title' ? 700 : 400};
    line-height: 20px;
    letter-spacing: 0.5px;
    text-align: left;
    }
    &::first-letter {
        text-transform: uppercase
    }
    @media (max-width: 767px) {
        font-size: 13px;
        line-height: 17px;
    }
    &.subtitle-desc {
        @media (max-width: 768px) {
            max-width: 26ch;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
`;
export const BannerNotifiSubCommonSegment = styled.div`
   {
    font-family: Verizon NHG DS;
    font-size: 14px;
    font-weight: ${({ segment }) => segment === 'title' ? 700 : 400};
    line-height: 20px;
    letter-spacing: 0.5px;
    text-align: left;
    }
    &::first-letter {
        text-transform: uppercase
    }

    @media (max-width: 768px) {
        font-size: 12px
    }

    @media (max-width: 480px) {
        font-size: 10px
    }
`;

export const CloseNotifiBanner = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    flex-shrink: 0;
    min-height: 44px;
`;
export const GotoEventNotifiBanner = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    flex-shrink: 0;
    min-height: 44px;
    margin-left: auto;
`;

export const BannerCommonNotify = styled.div`
    border-bottom: ${({ isEventAlert, bannerType }) => isEventAlert ? (bannerType == 'critical' ? '4px solid #FF8027' : '4px solid #0089EC') : 'none'};
    & > div > div > div {
        max-width: 100%;
    }
    &::first-letter {
        text-transform: uppercase
    }

    /* Mobile/tablet: full width */
    @media (max-width: 1399px) {
        margin-left: 0;
        width: 100%;
    }
`;